import { SubscriptionDto } from '@/shared/apis/fastmile/models'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { SubscriptionState } from './models/Subscription'
import { fetchSubscription } from './thunks/fetchSubscription'

export const initialSubscriptionState: SubscriptionState = {
  data: null,
  isLoading: false,
  isError: false,
  error: null,
}

export const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: initialSubscriptionState,
  reducers: {
    clearSubscription: (state) => {
      state.data = null
      state.isError = false
      state.error = null
    },
    setSubscription: (state, action: PayloadAction<SubscriptionDto>) => {
      state.data = action.payload
      state.isError = false
      state.error = null
    },
    clearSubscriptionError: (state) => {
      state.isError = false
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubscription.fulfilled, (state, action) => {
        state.isLoading = false
        state.isError = false
        state.error = null
        state.data = action.payload || null
      })
  },
})

export const { clearSubscription, setSubscription, clearSubscriptionError } = subscriptionSlice.actions